import { ReactNode } from 'react';
import { useHistory } from 'react-router-dom';
import { SectionNavigation } from '../../constants/common';

interface ActionCardProps {
	data: {
		label: string;
		externalUrl?: string;
		value?: any;
		icon?: React.ReactElement;
		children?: any;
	};
	onAction?: (value: SectionNavigation) => void;
	handleRemoveOverflow?: () => void;
	cyTestRef?: string;
	isSectionNav?: boolean;
	children?: ReactNode;
}

const ActionCard = (props: ActionCardProps) => {
	const history = useHistory();
	return props.data.externalUrl ? (
		<a href={props.data.externalUrl} className="action-list-item" target="_blank" rel="noreferrer">
			{props.data.icon}
			<div className="action-list-item__content">
				{props.data.label} {props.children}
			</div>
		</a>
	) : (
		<li
			className="action-list-item"
			onClick={() => {
				props.isSectionNav ? props.onAction?.(props.data.value) : history.push(props.data.value);
				if (!!props.handleRemoveOverflow) {
					props.handleRemoveOverflow();
				}
			}}
			data-cy={props.cyTestRef}
		>
			{props.data.icon}
			<div className="action-list-item__content">
				{props.data.label} {props.children}
			</div>
		</li>
	);
};

export default ActionCard;
